<template>
  <div class="page" :class="{ toggle: toggleSidebar}">
    <div class="page-header-container">
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">แลนดิ้งเพจ</div>
          </div>
          <div class="actions">
            <router-link :to="'/landingpage/create'" class="btn btn-primary">
              <i class="fas fa-plus icon"></i> สร้างใหม่
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="container">
        <PreloaderSection
          v-if="loadLandingPageState.isLoading" />
        <div v-if="!loadLandingPageState.isLoading">
          <!-- render content -->
          <Section
            v-if="!loadLandingPageState.error">
            <template v-slot:section-filter>
              <div class="search-container">
                <input
                  class="form-control form-control-search"
                  :value="filter.q"
                  :placeholder="`ค้นหาด้วยชื่อ`"
                  @change="onSearch" />
              </div>
            </template>
            <!-- render content -->
            <template v-slot:section-body>
              <div v-if="!isEmpty()">
                <List>
                  <template v-slot:list-header>
                    <div class="list-item-detail">
                      <div class="list-item list-item-primary list-item-title">ชื่อ</div>
                      <!-- <div class="list-item">Url</div> -->
                      <div class="list-item list-item-create-at">เริ่มต้นการเผยแพร่</div>
                      <div class="list-item list-item-create-at">สิ้นสุดการเผยแพร่</div>
                      <div class="list-item list-item-action"></div>
                    </div>
                  </template>
                  <template v-slot:list-body>
                    <div class="list-item-container no-underline"
                      v-for="(item, itemIndex) in landingPage"
                      :key="itemIndex"
                      @click.stop="goToPageDetail(`/landingpage/${item.id}`, itemIndex, $event)">
                      <div class="list-item-detail">
                        <div class="list-item list-item-primary list-item-title">
                          <div class="title"><b>{{item.title}}</b></div>
                        </div>
                        <!-- <div class="list-item">
                          {{item.redirectUrl}}
                        </div> -->
                        <div class="list-item list-item-create-at">
                          {{formatDateTime(item.startPublish)}}
                        </div>
                        <div class="list-item list-item-create-at">
                          {{formatDateTime(item.endPublish)}}
                        </div>
                        <div class="list-item list-item-action">
                          <div class="action-container">
                            <router-link
                              class="btn btn-light btn-action"
                              :to="`/landingpage/${item.id}`">
                              <i class="fas fa-pencil-alt"></i>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </List>
                <div
                  class="pagination-container"
                  v-if="isShowPagination()">
                  <Pagination
                    :lastPage="lastPage" />
                </div>
              </div>
              <!-- empty list -->
              <EmptyMessage v-if="isEmpty()">
                <h3>ไม่มีข้อมูล</h3>
                <router-link
                  class="btn btn-light btn-lg mt-4"
                  :to="`/landingpage/create`">
                  สร้างแลนดิ้งเพจใหม่
                </router-link>
              </EmptyMessage>
              <EmptyMessage v-if="isEmptySeach()">
                <h3>ไม่พบแลนดิ้งเพจชั่นที่ค้นหา</h3>
                <button
                  type="button"
                  class="btn btn-light btn-lg mt-4"
                  @click="clearSearch">
                  ล้างการค้นหา
                </button>
              </EmptyMessage>
            </template>
          </Section>
          <!-- error from api -->
          <EmptyMessage v-if="loadLandingPageState.error">
            <h3>เกิดข้อผิดพลาดขณะโหลดข้อมูล</h3>
            <span
              slot="code"
              class="code">
              Code : {{loadLandingPageState.error.status || 'not found' }}
            </span>
            </EmptyMessage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { loadLandingPage } from '@/landingpage/api';
import dateFormetter from '@/utils/dateFormatter';
import Pagination from '@/components/Pagination.vue';
import Section from '@/components/Section.vue';
import List from '@/components/List.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';

export default {
  mixins: [dateFormetter],
  components: {
    Pagination,
    Section,
    List,
    EmptyMessage,
    PreloaderSection,
  },
  data() {
    return {
      landingPage: null,
      lastPage: null,
      toggleSidebar: false,
      loadLandingPageState: {
        isLoading: true,
        error: null,
      },
    };
  },
  computed: {
    filter() {
      return this.$route.query;
    },
  },
  watch: {
    filter(newValue) {
      this.load(newValue);
    },
  },
  created() {
    this.load(this.filter);
  },
  methods: {
    async load(filter) {
      try {
        const response = await loadLandingPage(filter);
        this.landingPage = response.data.data;
        this.lastPage = response.data.lastPage;
        this.loadLandingPageState.isLoading = false;
        this.loadLandingPageState.error = null;
      } catch (error) {
        this.loadLandingPageState.error = error.response;
        this.loadLandingPageState.isLoading = false;
      }
    },
    isEmptySeach() {
      return _.isEmpty(this.landingPage) && !_.every(this.filter, _.isEmpty);
    },
    isEmpty() {
      return _.isEmpty(this.landingPage) && _.every(this.filter, _.isEmpty);
    },
    onSearch(event) {
      let filter;
      if (event.target.value) {
        filter = { ...this.filter, q: event.target.value };
      } else {
        filter = { ...this.filter };
        delete filter.q;
      }
      this.$router.push({ query: { ...filter } });
    },
    clearSearch() {
      const filter = null;
      this.$router.push({ query: { ...filter } });
    },
    isShowPagination() {
      return this.lastPage > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/layouts/page.scss';
@import './src/assets/scss/themes/components/form.scss';

.toggle {
  transition: all 0.3s ease-out;
  margin-right: 250px;
}

@media (max-width: 575.98px) {

  .toggle {
    margin-right: 0px;
  }

  .list-item-container {
    .list-item-image {
    }

    .list-item-detail {
      .list-item {
        font-size: $font-size-base * 0.875;
        width: 70%;
        display: none;

        &.list-item-primary {
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          padding: $spacer * 0.25;
        }

        &.list-item-secondary {
          display: flex;
          order: -1;
          padding: $spacer * 0.25;
          font-size: $font-size-base * 0.875;
        }

        &.list-item-status {
          display: flex;
        }
      }
    }
  }
}

@media (min-width: 576px) and (max-width: 1023.98px) {
  .toggle {
    margin-right: 0px;
  }

  .list-item-container {
    .list-item-image {
    }

    .list-item-detail {
      .list-item {
        &.list-item-create-at {
          display: none;
        }
        &.list-item-date {
          display: none;
        }
        &.list-item-action {
          .action-container {
            .btn-external {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
